import { create } from 'zustand';
import { Tag } from '@flows.cash/types';
import { useTagsStore as useCoreTagsStore } from '@flows.cash/core';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';

interface TagsStore {
  tags: Tag[];
  isLoading: boolean;
  fetchTags: (userId: string) => Promise<void>;
  addTag: (tag: Omit<Tag, 'id' | 'created_at' | 'updated_at'>) => Promise<Tag>;
  deleteTag: (userId: string, tagId: string) => Promise<void>;
  updateTag: (tagId: string, updates: Partial<Omit<Tag, 'id' | 'user_id' | 'created_at' | 'updated_at'>>) => Promise<void>;
}

export type { Tag };

export const useTagsStore = () => {
  const { t } = useTranslation()
  const coreStore = useCoreTagsStore()

  return {
    ...coreStore,
    addTag: async (data: Parameters<typeof coreStore.addTag>[0]) => {
      try {
        await coreStore.addTag(data)
        toast.success(t('tags.addSuccess'))
      } catch (error) {
        toast.error(t('tags.addError'))
        throw error
      }
    },

    updateTag: async (tagId: string, data: Parameters<typeof coreStore.updateTag>[1]) => {
      try {
        await coreStore.updateTag(tagId, data)
        toast.success(t('tags.updateSuccess'))
      } catch (error) {
        toast.error(t('tags.updateError'))
        throw error
      }
    },

    deleteTag: async (userId: string, tagId: string) => {
      try {
        await coreStore.deleteTag(userId, tagId)
        toast.success(t('tags.deleteSuccess'))
      } catch (error) {
        toast.error(t('tags.deleteError'))
        throw error
      }
    }
  }
}
